import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Filtro } from 'src/app/models/filtro';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatPaginator, MatDialogRef, MAT_DIALOG_DATA, PageEvent, MatDialog } from '@angular/material';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { Router } from '@angular/router';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { TransportadoraService } from 'src/app/services/transportadora.service';
import { Transportadora } from 'src/app/models/transportadora';
import { CadastrarTransportadoraModalComponent } from './cadastrar-transportadora-modal/cadastrar-transportadora-modal.component';
import { PaginatorService } from 'src/app/services/paginator.service';

declare const $: any;

@Component({
  selector: 'app-transportadora-modal',
  templateUrl: './transportadora-modal.component.html',
  styleUrls: ['./transportadora-modal.component.scss']
})
export class TransportadoraModalComponent implements OnInit {
  transportadorasFiltradas: Transportadora[] = [];
  carregando = true;
  campoOrdenacao = 'fantasia';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  statusSelecionado = 1;
  tiposDeStatus = [{ id: 0, nome: 'Bloqueado' }, { id: 1, nome: 'Ativo' }];

  tiposPesquisa = [{ id: 0, nome: 'Documento' }, { id: 1, nome: 'Fantasia' }, { id: 2, nome: 'Razão' }, { id: 3, nome: 'Email' }];
  tipoPesquisaSelecionado: number;
  pesquisa: string;

  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private transportadoraService: TransportadoraService,
    public utilitarioService: UtilitarioService,
    private paginatorService: PaginatorService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    public dialogRef: MatDialogRef<TransportadoraModalComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarTransportadoras();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarTransportadoras();
    this.paginator.firstPage();
  }

  buscarTransportadoras() {
    this.carregandoService.mostra('buscaTransportadoras');

    this.transportadoraService.consultarTransportadorasComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.tipoPesquisaSelecionado, this.pesquisa, this.statusSelecionado).subscribe(dados => {
      this.transportadorasFiltradas = dados.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = dados.total;
      this.carregando = false;
      this.carregandoService.esconde('buscaTransportadoras');
    }, (erro) => {
      this.carregandoService.esconde('buscaTransportadoras');
      this.notificacaoService.erro(erro);
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarTransportadoras();
  }

  retornaPerfil(perfil) {
    switch (perfil) {
    case 1:
      return 'Op';

    case 2:
      return 'Ad';

    default:
      break;
    }
  }

  selecionaTransportadora(transportadora) {
    this.dialogRef.close(transportadora);
  }

  fechar() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {}

  abrirModalCadastroTransportadora(idTransportadora: string) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(CadastrarTransportadoraModalComponent, {
      width: largura > 1024 ? '1000px' : $('body').width().toString() + 'px',
      panelClass: 'modal-card',
      data: {
        idTransportadora
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarTransportadoras();
      }
    });
  }
}
